import styled, { keyframes } from 'styled-components';

const swing = keyframes`
    10% {
      -webkit-transform: rotate3d(0, 0, 1, 15deg);
      transform: rotate3d(0, 0, 1, 15deg);
    }
    20% {
      -webkit-transform: rotate3d(0, 0, 1, -10deg);
      transform: rotate3d(0, 0, 1, -10deg);
    }
    30% {
      -webkit-transform: rotate3d(0, 0, 1, 5deg);
      transform: rotate3d(0, 0, 1, 5deg);
    }
    40% {
      -webkit-transform: rotate3d(0, 0, 1, -5deg);
      transform: rotate3d(0, 0, 1, -5deg);
    }
    50% {
      -webkit-transform: rotate3d(0, 0, 1, 0deg);
      transform: rotate3d(0, 0, 1, 0deg);
    }
  `;

const EventsBlockWrapper = styled.div`
  padding: 0.7em;
  display: flex;
  align-items: center;
  background: ${p => p.isActive && p.theme.color.veryLightGold};
  color: ${p => p.theme.color.text};
  border-radius: 4px;
  ${p =>
    p.isActive &&
    `transition: opacity 0.25s ease-in-out;
  :hover {
    cursor: pointer;
    opacity: 0.8;
  }`};
  svg {
    min-width: 24px;
    transform-origin: top;
    position: relative;
    &.animated {
      animation: ${swing} 5s ease-in-out 0s infinite;
    }
  }
  .msg {
    padding-left: 0.5em;
    font-size: 0.9em;
    text-overflow: ellipsis;
    display: block;
  }
`;

export default {
  EventsBlockWrapper
};
